import { Component, Input } from '@angular/core';

export interface IBreadcrumb {
  label: string;
  url?: string;
  queryParams?: { [key: string]: any };
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  @Input() breadcrumbList: IBreadcrumb[] | undefined;
}
